// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2Ibpc","inputWrap":"styles_inputWrap__16IEn","input":"styles_input__FRgcy"};